export enum GroupSeatType {
  Member = 'member',
  Field = 'field',
  Guest = 'guest',
  Viewer = 'viewer',
}
